import { v4 } from "uuid";
import { ConditionGroup } from "./ConditionGroup";
import { ConditionPrimitive } from "./ConditionPrimitive";

export interface ICondition {
    readonly id: string;
}

export abstract class Condition implements ICondition {
    public readonly id: string = v4();

    public static ResolveConcreteCondition(condition: ICondition) {
        if (ConditionPrimitive.isConditionPrimitive(condition))
            return new ConditionPrimitive(condition);
        else if (ConditionGroup.isConditionGroup(condition))
            return new ConditionGroup(condition);
        else throw new Error("Unkown condition detected.");
    }

    public static ExtractPropertyNames(condition: ICondition): string[] {
        if (ConditionPrimitive.isConditionPrimitive(condition))
            return [condition.propertyName];
        else if (ConditionGroup.isConditionGroup(condition))
            return condition.subRules.flatMap(this.ExtractPropertyNames);
        else throw new Error("Unkown condition detected.");
    }
}
